import { ALERTS_URL } from 'features/alerts/paths'
import {
  ASK_YOGI_CONVERSATION_URL,
  ASK_YOGI_SHARE_URL,
  ASK_YOGI_URL,
} from 'features/ask-yogi/paths'
import { CATALOG_DETAIL_URL, CATALOG_URL } from 'features/catalog/paths'
import { COVERAGE_URL } from 'features/coverage/paths'
import { FEEDBACK_DETAIL_URL, FEEDBACK_URL } from 'features/feedback/paths'
import { KEYWORDS_DETAIL_URL, KEYWORDS_URL } from 'features/keywords/paths'
import { PDP_DETAIL_URL, PDP_URL } from 'features/pdp/paths'
import { PRODUCT_WATCH_URL } from 'features/product-watch/paths'
import { RECOMMENDATIONS_URL } from 'features/recommendations/paths'
import { SAVED_VIEWS_URL } from 'features/saved-views/paths'
import { SOURCE_UPLOAD_URL } from 'features/source-upload/paths'
import { AGENTS_URL, TREND_DETECTION_URL } from 'features/trend-detection/paths'
import { DASHBOARDS_2_1_URL } from 'src/features/dashboards-v2-1/paths'

export function checkRouteAccess(
  routeUrl: string,
  featureFlags: Record<string, boolean>,
  pageSettings: Record<string, unknown>,
  projectId: string,
): boolean {
  switch (routeUrl) {
    case ASK_YOGI_URL:
    case ASK_YOGI_CONVERSATION_URL:
    case ASK_YOGI_SHARE_URL:
      // hide_ask_yogi: This is to hide Ask Yogi for Disney. Delete these checks once they approve Ask Yogi usage.
      return (
        !(pageSettings as { chadgent?: { hidden?: boolean } })?.chadgent
          ?.hidden && !featureFlags?.['hide_ask_yogi']
      )

    case DASHBOARDS_2_1_URL:
      return !!featureFlags?.['dashboards_2_1']

    case TREND_DETECTION_URL:
    case AGENTS_URL:
      return !!featureFlags?.['trend_detection_prototype']

    case SOURCE_UPLOAD_URL:
      return !!featureFlags?.['source_upload']

    // The flag that offers the social topic setup skill, which is how social
    // topics get built; Coverage only has those to show so far.
    case COVERAGE_URL:
      return !!featureFlags?.['ask_yogi_skill_social_topic_setup']

    case FEEDBACK_URL:
    case FEEDBACK_DETAIL_URL:
      return !(pageSettings as { feedback?: { hidden?: boolean } })?.feedback
        ?.hidden

    case KEYWORDS_URL:
    case KEYWORDS_DETAIL_URL:
      return !(pageSettings as { keywords?: { hidden?: boolean } })?.keywords
        ?.hidden

    case CATALOG_URL:
    case CATALOG_DETAIL_URL:
      return !(pageSettings as { catalog?: { hidden?: boolean } })?.catalog
        ?.hidden

    case PRODUCT_WATCH_URL:
      return (
        !!featureFlags?.['product_watch'] &&
        projectId === '74170bb4-7763-4ffb-8618-31b409b0173e'
      )

    case PDP_URL:
    case PDP_DETAIL_URL:
      return (
        !(pageSettings as { pdp?: { hidden?: boolean } })?.pdp?.hidden &&
        !!featureFlags?.['pdp_tool']
      )

    case ALERTS_URL:
      return !(pageSettings as { alerts?: { hidden?: boolean } })?.alerts
        ?.hidden

    case SAVED_VIEWS_URL:
      return !(pageSettings as { saved_views?: { hidden?: boolean } })
        ?.saved_views?.hidden

    case RECOMMENDATIONS_URL:
      return !(pageSettings as { recommendations?: { hidden?: boolean } })
        ?.recommendations?.hidden

    default:
      return true
  }
}
